var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoExpanded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1901.6 557.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6745",
    "data-name": "Grupo 6745",
    transform: "translate(11417 -270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4537",
    "data-name": "Trazado 4537",
    d: "M941.2,92.8c-2.8,1.3-4.8,2.5-6.9,3.3-13,4.6-26,9.1-39.9,14C879.9,84.7,859.2,68.8,830,65c-20.1-2.6-39-.2-56.6,9.9C736.8,96,720.8,142,735.5,183.2c14.3,40.1,55.2,62.5,100,55.4,33.5-5.4,61.1-37.3,59.4-59.9H805.1c-1-16.2-.5-31.2-.4-46,10.7-3.3,120.2-4.4,144.2-1.5a142.153,142.153,0,0,1-1.1,53.2C934.2,249,883.4,289.2,816.9,290c-70.4.8-117-45.5-132.1-87.5C653.1,114,706.9,33.6,781.9,17.2c39.3-8.6,76.8-3.2,111.8,16.9,23,13.2,39.1,33.1,47.5,58.7",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4538",
    "data-name": "Trazado 4538",
    d: "M1341.2.8h49.2c1.6,16.7.6,33.2.8,49.7.2,16.1,0,32.2,0,50.4,5.1-2.5,8.3-3.9,11.4-5.6,73.1-40.4,147.3,10.5,150.9,82.1,1,20.8-1.2,41-11.3,59.6-28.4,52.7-84.1,64.8-132.3,43.3-5.5-2.5-10.7-5.7-17-9-1.2,4.4-2.1,7.9-3.2,12.2h-47.8c-2.7-10.2-3.6-260.5-.7-282.7m161.6,185.7c.1-29.2-13.7-50.1-37.9-57.4-29.1-8.8-61.1,7.1-69.7,36.3-10.7,36.3,4.5,65.4,34.7,76,39.5,13.9,75-15.4,72.9-54.9",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4539",
    "data-name": "Trazado 4539",
    d: "M1738.9,100.8c.8-5.3,1.3-8.6,1.9-12.7h50.1V283.4h-49.8c-.7-3.3-1.4-7.2-2.1-10.4-13.4,5-25.8,11.2-39,14.4-58.8,14-113.2-24.3-121-84.3-4.5-35,3.2-66,27.9-92.3,33.9-36.1,83.6-35.6,118.4-17.7,4.1,2,8.1,4.5,13.6,7.7m-56.2,143.7c32,.1,57-25.4,57.1-58.5.1-32.7-25.4-59.6-56.5-59.6-32.2-.1-55.5,25.1-55.4,59.7.2,34.4,22.6,58.3,54.8,58.4",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4540",
    "data-name": "Trazado 4540",
    d: "M1086.2,184.1c.1-60.3,48.3-103.2,109.4-101.9,63.1,1.4,107.4,48.4,104.1,109.8-3,57.4-49.4,99.3-110.6,97.5-60-1.8-104.5-47.3-102.9-105.4m107.2,60.4c31.1,0,56.1-25.7,56.4-58.2.3-31.9-25.1-59-55.6-59.4-31.6-.4-57.2,25.6-57.7,58.6-.5,32.7,24.8,59,56.9,59",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4541",
    "data-name": "Trazado 4541",
    d: "M996,0h49.5V284.3H997.4C994,273.4,992.7,26.5,996,0",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4542",
    "data-name": "Trazado 4542",
    d: "M1848.9.9h49.6V283.4H1850c-3.1-10.2-4.2-259.8-1.1-282.5",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4543",
    "data-name": "Trazado 4543",
    d: "M325.7,248.5V454.6a49.7,49.7,0,0,1-99.4,0V248.5Z",
    transform: "translate(-11417 270)",
    fill: "#00b087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4544",
    "data-name": "Trazado 4544",
    d: "M189.2,248.5V507.7a49.7,49.7,0,1,1-99.4,0V248.5Z",
    transform: "translate(-11417 270)",
    fill: "#102749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4545",
    "data-name": "Trazado 4545",
    d: "M465.7,248.5V406.9a49.7,49.7,0,0,1-99.4,0V248.5Z",
    transform: "translate(-11417 270)",
    fill: "#186485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4546",
    "data-name": "Trazado 4546",
    d: "M553.3,132.6V54.1a25.056,25.056,0,0,0-.6-5.5,38.52,38.52,0,0,0-38.4-37.3H38.5A37.913,37.913,0,0,0,11.4,22.6,38.593,38.593,0,0,0,0,49.7a36.362,36.362,0,0,0,.3,4.8A25.6,25.6,0,0,0,5.7,69.8,38.39,38.39,0,0,0,38.4,88.1H63.6v22.2a5.8,5.8,0,0,0,5.8,5.8h2.1a5.8,5.8,0,0,1,5.8,5.8v5.6a5.8,5.8,0,0,0,5.8,5.8h3v84.6H467.8V133.2a4.869,4.869,0,0,0,1.2.1h11.3c2.9,0,5.2-1.9,5.2-4.2v-8.8c0-2.3,2.3-4.2,5.2-4.2s5.2-1.9,5.2-4.2V88.1h18.6a38.464,38.464,0,0,0,26-10.2v54.3a21.089,21.089,0,0,0-15.1,20.2v21.1h42.1V152.4a21.22,21.22,0,0,0-14.2-19.8",
    transform: "translate(-11417 270)",
    fill: "#00b087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4547",
    "data-name": "Trazado 4547",
    d: "M1095.9,468.2a50.79,50.79,0,0,1-10.7,10.5,52,52,0,1,1-31.2-93.6,50.841,50.841,0,0,1,30.9,10.5,53.392,53.392,0,0,1,10.3,10.4l-7.2,6.5a38.47,38.47,0,0,0-8.4-8.7,40.009,40.009,0,0,0-25.6-8.7c-23.1,0-41.2,18.1-41.2,41.9s18.1,41.9,41.2,41.9a41.687,41.687,0,0,0,26-8.7,42.2,42.2,0,0,0,8.7-8.7Z",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4548",
    "data-name": "Trazado 4548",
    d: "M1204.3,386.5h10.1l41.9,101.2h-11.6l-11.6-28.2h-47.7l-11.6,28.2h-11.6Zm24.6,62.9-19.5-47.7-19.5,47.7Z",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4549",
    "data-name": "Trazado 4549",
    d: "M1332.2,386.5h9.4l41.9,54.9,41.9-54.9h9.4V487.7H1424V405.3l-40.5,53.5L1343,405.3v82.4h-10.8Z",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4550",
    "data-name": "Trazado 4550",
    d: "M1523,386.5h38.3c18.8,0,32.5,13.9,32.5,31.8s-13.7,31.8-32.5,31.8h-27.5v37.6H1523Zm38.3,53.5c13.2,0,21.7-8.5,21.7-21.7s-8.5-21.7-21.7-21.7h-27.5V440Z",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4551",
    "data-name": "Trazado 4551",
    d: "M1673.4,386.5h10.8v61.4c0,18.1,13,31.1,30.4,31.1,17.3,0,30.4-13,30.4-31.1V386.5h10.8v61.4a41.2,41.2,0,1,1-82.4,0Z",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4552",
    "data-name": "Trazado 4552",
    d: "M1840.3,466.6a27.808,27.808,0,0,0,6.6,6.2c4.5,3.3,11.4,6.2,20.8,6.2,15.2,0,23.1-7.8,23.1-18.8,0-25.9-54.9-11.7-54.9-47.7,0-14.6,12.4-27.5,32.5-27.5a39.444,39.444,0,0,1,22.1,6.5,33.767,33.767,0,0,1,7.5,6.5l-7.2,7.2a34.338,34.338,0,0,0-5.6-5.1,30.145,30.145,0,0,0-16.8-5.1c-13.9,0-21.7,8.2-21.7,17.3,0,26,54.9,11.7,54.9,47.7,0,16.6-12.3,28.9-34,28.9-11.6,0-20.1-3.6-25.7-7.5a31.9,31.9,0,0,1-8.2-7.7Z",
    transform: "translate(-11417 270)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3967",
    "data-name": "Rect\\xE1ngulo 3967",
    width: 1901.6,
    height: 557.4,
    transform: "translate(-11417 270)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExpanded);
export default __webpack_public_path__ + "static/media/logo_expanded.1ccbbdbc.svg";
export { ForwardRef as ReactComponent };